<template>
    
    <!-- Page Title
        ============================================= -->
    <section id="page-title">

        <div class="container clearfix">
            <h1 v-if="programData != null && !loading">{{ programData.name }}</h1>

        </div>

    </section>
  
    <!-- #page-title end -->
    <!-- Content
    ============================================= -->
    <section id="content">
        <div class="content-wrap">


            <div class="container clearfix" v-if="loading">
                <div class="loader" title="0">
                    <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
                         viewBox="0 0 40 40" enable-background="new 0 0 80 80" xml:space="preserve">
                    <path opacity="0.2" fill="#000"
                          d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
                    <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    C22.32,8.481,24.301,9.057,26.013,10.047z">
                    <animateTransform attributeType="xml" attributeName="transform" type="rotate"
                                      from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite" />
							</path>
						</svg>
                </div>
            </div>
            <!--<div class="container">
    </div>-->
            <div v-if="(programData == null || programData?.programStatus != 2) && !loading" class="container clearfix">
                <h2>{{$t("Program-Details")}} </h2>
            </div>
            <div v-else-if="!loading" class="container clearfix">
                <div class="row mt-4 col-mb-50">
                    <div class="col-md-6">
                        <!--<h3 v-if="programData != null"> ما هو {{ programData.name }}؟ </h3>-->
                        <div v-if="programData == null">
                            <p>
                                لا يوجد
                            </p>
                        </div>
                        <div v-else>
                            <p v-if="programData.description == null">

                            </p>
                            <p v-html="programData.description" v-else> </p>
                        </div>


                        <h3>{{$t("Program-Frequently")}} </h3>
                        <router-link :to="{name:'CommonQuestions'}" class="button button-3d button-mini button-rounded button-dirtygreen">{{$t("Program-FrequentlyAskedQuestions")}}</router-link>
                        <div class="btn-group d-block mt-3 mb-2" role="group">
                            <a :href="programData?.descFilePath" :download='$t("Program-ProgramJobDescription")' class="btn btn-primary mb-1 ml-5">
                                {{$t("Program-ProgramJobDescription")}}    {{ programData.name }}
                            </a>
                            <a :href="programData?.approvedSpecialitiesFilePath" :download='$t("Program-AcceptedMajors")' class="btn btn-primary mb-1 ml-5">
                                {{$t("Program-AcceptedMajors")}} {{ programData.name }}
                            </a>
                            <a :href="programData?.studyPlanFilePath" :download='$t("Program-StudyPlanOfTheProgram")' class="btn btn-primary mb-1 ml-5"> {{$t("Program-StudyPlanOfTheProgram")}} ​​​​​​</a>
                        </div>
                        <p>
                            {{$t("Program-ApplyForThePrograme")}}
                            <a :href="applicantURL" target="_blank" class="ms-1 fw-bolder text-3">
                                {{$t("Program-ClickHere")}}
                            </a>
                        </p>
                        <p>
                            {{$t("Program-Questions")}}
                            <a :href="contactUsURL" target="_blank" class="ms-1 fw-bolder text-3">
                                {{$t("Program-Communication")}}
                            </a>
                            {{$t("Program-OrUse")}}
                            <a href="#" @click="minzedChat" class="ms-1 fw-bolder text-3">
                                {{$t("Program-InteractiveChat")}}
                            </a>
                        </p>
                        <h4 class="mb-3" v-if="programData.pdfAttachmentList != null && programData.pdfAttachmentList.length > 0">{{$t("Program-Attachment")}}</h4>
                        <ol class="list-group list-group-numbered mb-3">
                            <li v-for="(file, index) in programData.pdfAttachmentList" :key="file.id" class="list-group-item d-flex justify-content-start">
                                <a :download="file.fileName" :href="file.filePath">
                                    <div class="fw-bold">{{file.fileName}}</div>
                                </a>
                            </li>
                        </ol>
                        <h4 class="mb-3" v-if="programData.links != null && programData.links.length > 0">{{$t("Program-ImportantLinks")}}</h4>
                        <ol class="list-group list-group-numbered mb-3">
                            <li v-for="(link, index) in programData.links" :key="link.id" class="list-group-item d-flex justify-content-start">
                                <a target="_blank" :href="link.url">
                                    <div class="fw-bold">{{link.linkText}}</div>
                                </a>
                            </li>
                        </ol>
                        <!--<div class="divider divider-center mt-2 mb-4"><i class="icon-circle"></i></div>-->
                        <h3 class="text-3 text-center">{{$t("Program-Interested")}}</h3>
                        <div class="row">
                            <div class="col" v-if="programData.programCandidateCriteriaStatus">
                                <div class="feature-box fbox-center fbox-outline fbox-lg fbox-effect">
                                    <div class="fbox-icon mb-2">
                                        <router-link :to="{name:'ProgramsTypePage', params:{typeId:1 ,id:programId}}"> <i class="fa-solid fa-user-doctor"></i></router-link>
                                    </div>
                                    <div class="fbox-content">
                                        <h3>{{$t("Program-AnApplicant")}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col" v-if="programData.programTrainingCenterStatus">
                                <div class="feature-box fbox-center fbox-outline fbox-lg fbox-effect">
                                    <div class="fbox-icon mb-2">

                                        <router-link :to="{name:'ProgramsTypePage', params:{typeId:2,id:programId}}"> <i class="fa-solid fa-square-h"></i></router-link>
                                    </div>
                                    <div class="fbox-content">
                                        <h3>{{$t("HomePage-TrainingCenter")}}</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="col" v-if="programData.programEmployerStatus">
                                <div class="feature-box fbox-center fbox-outline fbox-lg fbox-effect">
                                    <div class="fbox-icon mb-2">
                                        <router-link :to="{name:'ProgramsTypePage', params:{typeId:3,id:programId}}">  <i class="fa-solid fa-briefcase"></i></router-link>
                                    </div>
                                    <div class="fbox-content">
                                        <h3>{{$t("HomePage-Employer")}}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="programData.videoFileList != null && programData.videoFileList.length > 0">
                        <div class="row">
                            <div class="col-md-12" v-for="(file, index) in programData.videoFileList" :key="file.id">
                                <video width="560" height="315" controls @error="hideVideo">
                                    <source :src="file.filePath">
                                </video>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


        </div>
    </section><!-- #content end -->
</template>
<script>
    import * as programService from './Service/ProgramService'

    export default {
        name: 'ProgramComponent',
        data() {
            return { baseUrl: process.env.BASE_URL, programData: null, contactUsURL: "", applicantURL: "", programId: 0, loading:false }
        },
        created() {
            this.loading = true;
            
            programService.getProgram(this);
        },
        methods: {
            hideVideo(e) {
                e.target.style.display = "none";
            },
            minzedChat() {
                document.getElementById("minzedChat").click();
            }
            //updated() {
            //    programService.OnCompletedLoadPage();
            //}
        }
    }
</script>
<style>
    .ml-5 {
        margin-left: 5px !important;
    }
    .loader {
        margin: 0 0 2em !important;
        height: 100px !important;
        width: 100% !important;
        text-align: center !important;
        padding: 1em !important;
        margin: 0 auto 1em !important;
        display: inline-block !important;
        vertical-align: top !important;
    }
    svg path, svg rect {
        fill: #006096 !important;
    }
</style>